'use strict';

var getBuiltIn = require('../internals/get-built-in');

var definePropertyModule = require('../internals/object-define-property');

var DESCRIPTORS = require('../internals/descriptors');

var SPECIES = require('../internals/well-known-symbol')('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var C = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;
  if (DESCRIPTORS && C && !C[SPECIES]) defineProperty(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};